import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3c77c10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = {
  key: 1,
  ref: "showbtn"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "col" }
const _hoisted_6 = {
  key: 0,
  style: {"cursor":"pointer"}
}
const _hoisted_7 = {
  key: 1,
  style: {"cursor":"pointer"}
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "sadams-4"
}

import { getEntityTranslation } from "@/helpers";
import { Tol2008TreeDto } from "@api/tol2008-tree-dto";
import { computed } from "vue";
import { uniqBy } from "lodash";
import { onMounted, PropType, ref, watch } from "vue";
import Tol2008Item from "./Tol2008Item.vue";
import publicFormApi from "@/publicFormApi";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tol2008Select',
  props: {
	modelValue: {
		type: [Number, Array, null] as PropType<null | number | Tol2008TreeDto[]>,
		required: true,
	},
	multi: {
		type: Boolean,
		default: false,
	},
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const isOpen = ref<boolean>(false);

watch(isOpen, (newVal) => {
	if (newVal) {
		selectedTopLevelTol.value = null;
		closeAll();
	}
});

const emit = __emit;

const props = __props;

const expand = (tol: Tol2008TreeDto) => {
	if (loadedTols.value.some((r) => r.parentId == tol.id)) {
		const loadedTol = loadedTols.value.filter((r) => r.id == tol.id)[0];
		if (loadedTol) {
			loadedTol.isOpen = true;
		}
	} else {
		const loadedTol = loadedTols.value.filter((r) => r.id == tol.id)[0];
		if (loadedTol) {
			loadedTol.isLoading = true;
		}

		if (!tol.id) {
			return;
		}

		publicFormApi.call.form.get.tol2008ByParentId(tol.id).then((r) => {
			if (r.isSuccessful && r.data) {
				loadedTols.value.push(...r.data);
				uniqLoadedTols();
				const loadedTol = loadedTols.value.filter((l) => l.id == tol.id)[0];
				if (loadedTol) {
					loadedTol.isOpen = true;
					loadedTol.isLoading = false;
				}
			}
		});
	}
};

const uniqLoadedTols = () => {
	loadedTols.value = uniqBy(loadedTols.value, (r) => r.id);
};

const close = (tol: Tol2008TreeDto) => {
	const loadedTol = loadedTols.value.filter((r) => r.id == tol.id)[0];
	if (loadedTol) {
		loadedTol.isOpen = false;
	}
};

const closeAll = () => {
	loadedTols.value.forEach((r) => (r.isOpen = false));
};

const select = (tol: Tol2008TreeDto) => {
	if (props.multi) {
		modelValueAsMulti.value.push(tol);
	} else {
		modelValueAsSingle.value = tol.id;
	}
};

const removeSelection = (tol: Tol2008TreeDto) => {
	if (props.multi) {
		modelValueAsMulti.value = modelValueAsMulti.value.filter((r) => r.id != tol.id);
	} else {
		modelValueAsSingle.value = null;
	}
};

const loadedTols = ref<Tol2008TreeDto[]>([]);

const topLevelTols = computed(() => loadedTols.value.filter((r) => r.parentId == null));

const selectedTopLevelTol = ref<Tol2008TreeDto | null>(null);

const clickTopLevelTol = (tol: Tol2008TreeDto) => {
	if (selectedTopLevelTol.value && tol.id == selectedTopLevelTol.value.id) {
		selectedTopLevelTol.value = null;
		loadedTols.value.forEach((r) => {
			r.isOpen = false;
		});
		return;
	} else {
		loadedTols.value.forEach((r) => {
			r.isOpen = false;
		});
		selectedTopLevelTol.value = tol;
	}

	const hasLoadedChildren = loadedTols.value.some((r) => r.parentId == tol.id);

	if (!hasLoadedChildren) {
		if (!tol.id) {
			return;
		}
		publicFormApi.call.form.get.tol2008ByParentId(tol.id).then((r) => {
			if (
				r.isSuccessful &&
				r.data &&
				selectedTopLevelTol.value &&
				selectedTopLevelTol.value.id == tol.id
			) {
				selectedTopLevelTol.value.children = r.data;
				loadedTols.value.push(...r.data);
			}
		});
	}
};

onMounted(() => {
	publicFormApi.call.form.get.tol2008TopLevel().then((r) => {
		if (r.isSuccessful && r.data) {
			loadedTols.value = r.data;
		}
	});
});

const fixedTols = ref<Tol2008TreeDto[]>([]);

const modelValueComputed = computed(() => props.modelValue);

watch(
	modelValueComputed,
	(newVal) => {
		if (Array.isArray(newVal)) {
			//
		} else if (newVal != null) {
			publicFormApi.call.form.get.tol2008ById(newVal).then((r) => {
				if (r.isSuccessful && r.data) {
					fixedTols.value = [r.data];
					singleValueObj.value = r.data;
				}
			});
		}
	},
	{ immediate: true }
);

const modelValueAsSingle = computed<number | null>({
	get() {
		if (props.multi) {
			return null;
		}
		return props.modelValue as number | null;
	},
	set(newVal: number | null) {
		emit("update:modelValue", newVal);
	},
});

const singleValueObj = ref<Tol2008TreeDto | null>(null);

watch(modelValueAsSingle, (newVal) => {
	if (!newVal) {
		singleValueObj.value = null;
		return;
	}
	publicFormApi.call.form.get.tol2008ById(newVal).then((r) => {
		if (r.isSuccessful && r.data) {
			singleValueObj.value = r.data;
		}
	});
});

const modelValueAsMulti = computed<Tol2008TreeDto[]>({
	get() {
		if (!props.multi) {
			return [];
		}
		return (props.modelValue || []) as Tol2008TreeDto[];
	},
	set(newVal: Tol2008TreeDto[]) {
		emit("update:modelValue", newVal);
	},
});

//const openSelectionBtn = ref<HTMLElement | null>(null);

return (_ctx: any,_cache: any) => {
  const _component_HakoButton = _resolveComponent("HakoButton")!
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoSpinner = _resolveComponent("HakoSpinner")!
  const _component_HakoWindow = _resolveComponent("HakoWindow")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.multi && singleValueObj.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, _toDisplayString(singleValueObj.value.rootCode) + " " + _toDisplayString(singleValueObj.value.code) + " " + _toDisplayString(_unref(getEntityTranslation)(singleValueObj.value.translations, "name")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close ms-2",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (removeSelection(singleValueObj.value)))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (!__props.multi && !singleValueObj.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_HakoButton, {
            ref: "openSelectionBtn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("generic.selectTol2008")), 1)
            ]),
            _: 1
          }, 512)
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_HakoWindow, {
      modelValue: isOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpen).value = $event)),
      title: "Tol2008",
      size: "l",
      positionUnderElement: (_ctx.$refs.showbtn as HTMLElement)
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topLevelTols.value, (topLevelTol) => {
          return (_openBlock(), _createElementBlock("div", {
            key: topLevelTol.id?.toString()
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["d-flex", {
						'tol': true,
						'is-open': selectedTopLevelTol.value && selectedTopLevelTol.value.id == topLevelTol.id,
					}]),
              onClick: _withModifiers(($event: any) => (clickTopLevelTol(topLevelTol)), ["stop","prevent"]),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(topLevelTol.code) + ": " + _toDisplayString(_unref(getEntityTranslation)(topLevelTol.translations, "name")) + " ", 1),
                (topLevelTol != selectedTopLevelTol.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_component_HakoBsIcon, { icon: "plus-square" })
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_HakoBsIcon, { icon: "dash-square" })
                    ]))
              ])
            ], 10, _hoisted_4),
            (selectedTopLevelTol.value == topLevelTol)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (selectedTopLevelTol.value.children && selectedTopLevelTol.value.children.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTopLevelTol.value.children, (tol) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: tol.id?.toString()
                          }, [
                            _createVNode(Tol2008Item, {
                              tol2008Item: tol,
                              loadedTols: loadedTols.value,
                              onExpand: expand,
                              onClose: close,
                              onSelect: select,
                              onRemoveSelection: removeSelection,
                              selectionMulti: modelValueAsMulti.value,
                              selectionSingle: modelValueAsSingle.value
                            }, null, 8, ["tol2008Item", "loadedTols", "selectionMulti", "selectionSingle"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock(_component_HakoSpinner, { key: 1 }))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "positionUnderElement"])
  ]))
}
}

})